import { render, staticRenderFns } from "./beSankey.vue?vue&type=template&id=740efe12&"
import script from "./beSankey.vue?vue&type=script&lang=js&"
export * from "./beSankey.vue?vue&type=script&lang=js&"
import style0 from "./beSankey.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports